import { GateNorIcon } from './GateNorIcon';

/**
 * author: Nick
 * id 9BFED3B5-B327-480D-BFCD-18F9CC52D82A
 * name gate-nor
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-nor.svg
 * tags
 */
export const LogicGateNorIcon = GateNorIcon;
export default LogicGateNorIcon